type BrandLogoProps = {
  size?: number;
  className?: string;
};

export function BrandLogo({ size = 38, className }: BrandLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M45 85C30 85 15 75 15 50C15 25 35 15 55 15C75 15 85 30 85 50C85 65 75 80 55 80C50 80 40 85 35 90C38 82 40 78 40 75"
        stroke="var(--locs-forest, #245B45)"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35 60C30 50 35 30 55 30C75 30 80 50 70 70C60 85 45 80 40 75"
        stroke="var(--locs-terracotta, #B95736)"
        strokeWidth="5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M42 35C45 32 55 32 58 35"
        stroke="var(--locs-forest, #245B45)"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
